import { render, staticRenderFns } from "./studio.vue?vue&type=template&id=03cc7e3a&scoped=true&"
import script from "./studio.vue?vue&type=script&lang=js&"
export * from "./studio.vue?vue&type=script&lang=js&"
import style0 from "./studio.vue?vue&type=style&index=0&id=03cc7e3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc7e3a",
  null
  
)

export default component.exports